import type { FaireProductEntity } from "../../entity_types/product";

export const p_uph79faf4n: FaireProductEntity = {
  token: "p_uph79faf4n",
  type: "product",
  name: "Arkansas State map Hammered Wide Metal Cuff Bracelet",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/0853363f44bd13f32c3206021db851c6e21ce2ed7312f47fc25ac6d9b6c667c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96f79593a05d3a6595d260c17b6c6d00dd122afaa94ad37267786aae9d29543c.jpeg",
    "https://cdn.faire.com/fastly/74093599e30a0744047699b2f63a69ed3188947e5701d637719970f3bccc47d6.jpeg",
    "https://cdn.faire.com/fastly/93319a23452adb0a5678be097236f1e44e466bacdfeb49eefc2724f66e0c3b13.jpeg",
    "https://cdn.faire.com/fastly/7be233d4f7755232f95c445f87a202e370bce5984c86380fda066c9e056ea139.jpeg",
    "https://cdn.faire.com/fastly/824f6cb3caa8f6c3c7564708ee6a8d594415a679c0db78e4a1c01455e2b42dd9.jpeg",
    "https://cdn.faire.com/fastly/484adfc10dbdbf812e25d16f1ef69dd93fd95004e2b1314efb1c146d50300119.jpeg",
    "https://cdn.faire.com/fastly/eedb88a18b0804aeb57536b972c861c5f97d17a9523fbe3589954f56d1eff36b.jpeg",
    "https://cdn.faire.com/fastly/e3231c4264028a665b645c859098d39b43f60092c630caac99ccfe9abc4bc8db.jpeg",
  ],
  priceDollars: 7.25,
  description:
    'Size : 2" H \nCuff\nThis wide cuff bracelet features a textured finish with a bold Arkansas state outline, perfect for showcasing local pride. A meaningful accessory that blends rustic charm with modern style, it makes a standout keepsake or gift for anyone wanting to celebrate their Arkansas roots and heritage.',
  tags: [],
  msrpDollars: 14.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:26.175Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
